module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ibWVudSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggaWQ9IlBhdGhfMzY5NzQiIGRhdGEtbmFtZT0iUGF0aCAzNjk3NCIgZD0iTTAsMEgyNFYyNEgwWiIgZmlsbD0ibm9uZSIvPgogIDxwYXRoIGlkPSJQYXRoXzM2OTc1IiBkYXRhLW5hbWU9IlBhdGggMzY5NzUiIGQ9Ik0zLDE4SDIxVjE2SDNabTAtNUgyMVYxMUgzWk0zLDZWOEgyMVY2WiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.svg
// module id = Ehsk
// module chunks = 0